import React from 'react';
import { SceneState, useSceneStore } from '../../state/sceneStore';

const ViewControlsPanel: React.FC = () => {
  const pointCloudVisible = useSceneStore((state: SceneState) => state.pointCloudVisible);
  const setPointCloudVisible = useSceneStore((state: SceneState) => state.setPointCloudVisible);
  const obstaclesVisible = useSceneStore((state: SceneState) => state.obstaclesVisible);
  const setObstaclesVisible = useSceneStore((state: SceneState) => state.setObstaclesVisible);
  const isAlignmentMode = useSceneStore((state: SceneState) => state.isAlignmentMode);
  const useOrthographic = useSceneStore((state: SceneState) => state.useOrthographic);
  const setUseOrthographic = useSceneStore((state: SceneState) => state.setUseOrthographic);
  const pointSize = useSceneStore((state: SceneState) => state.sceneOptions.pointSize);
  const setSceneOptions = useSceneStore((state: SceneState) => state.setSceneOptions);

  const panelStyle: React.CSSProperties = {
    background: 'rgba(25, 35, 45, 0.8)',
    color: 'white',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid #334155',
    marginBottom: '10px',
  };

  const buttonStyle: React.CSSProperties = {
    background: '#4f46e5',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  };

  const pointCloudLabel = isAlignmentMode ? 'Aligned Scans' : 'Point Cloud';

  return (
    <div style={panelStyle}>
      <h4>View Controls</h4>

      {/* Point Cloud Controls */}
      <div style={{ marginBottom: '20px' }}>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => setPointCloudVisible(!pointCloudVisible)}
            style={{
              ...buttonStyle,
              width: 'auto',
              flex: 1,
              background: pointCloudVisible ? '#10b981' : '#6b7280'
            }}
          >
            {pointCloudVisible ? 'Hide' : 'Show'} {pointCloudLabel}
          </button>
        </div>
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <button
            onClick={() => setObstaclesVisible(!obstaclesVisible)}
            data-testid="obstacles-visibility-toggle"
            style={{
              ...buttonStyle,
              width: 'auto',
              flex: 1,
              background: obstaclesVisible ? '#10b981' : '#6b7280'
            }}
          >
            {obstaclesVisible ? 'Hide' : 'Show'} Obstacles
          </button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
          <label style={{ fontSize: '12px', flex: '0 0 70px' }}>Point Size:</label>
          <input
            type="range"
            min="0.1"
            max="10"
            step="0.1"
            value={pointSize}
            onChange={(e) => setSceneOptions({ pointSize: parseFloat(e.target.value) })}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '12px', width: '30px', textAlign: 'right' }}>{pointSize.toFixed(1)}</span>
        </div>
      </div>

      {/* Grid Controls */}
      <div style={{ marginBottom: '20px' }}>
        <h5 style={{ marginTop: 0, marginBottom: '10px' }}>Grid Controls</h5>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <label style={{ fontSize: '12px', flex: '0 0 70px' }}>Cell Size:</label>
          <input
            type="range"
            min="0.1"
            max="10"
            step="0.1"
            value={useSceneStore((state) => state.sceneOptions.gridCellSize)}
            onChange={(e) => setSceneOptions({ gridCellSize: parseFloat(e.target.value) })}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '12px', width: '30px', textAlign: 'right' }}>
            {useSceneStore((state) => state.sceneOptions.gridCellSize).toFixed(1)}m
          </span>
        </div>
      </div>

      {/* 3D/Top-down View Control */}
      <div style={{ marginBottom: '20px' }}>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => setUseOrthographic(false)}
            style={{
              ...buttonStyle,
              width: 'auto',
              flex: 1,
              background: !useOrthographic ? '#10b981' : '#6b7280'
            }}
          >
            🎮 3D View
          </button>
          <button
            onClick={() => setUseOrthographic(true)}
            style={{
              ...buttonStyle,
              width: 'auto',
              flex: 1,
              background: useOrthographic ? '#10b981' : '#6b7280'
            }}
          >
            📐 Top-Down
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewControlsPanel;
